import { render, staticRenderFns } from "./hspt_header_card.vue?vue&type=template&id=145ba07c"
import script from "./hspt_header_card.vue?vue&type=script&lang=js"
export * from "./hspt_header_card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports